<template>
    <div class="row">
        <div class="col-12">
            <div id="carouselExampleIndicators3" class="carousel slide" data-ride="carousel">
                <ol class="carousel-indicators">
                    <li
                        class="li_carousel"
                        v-for="noticia,index of noticias" :key="index+'noticia'"
                        data-target="#carouselExampleIndicators3"
                        v-bind:data-slide-to="noticia.i">
                    </li>
                </ol>
                <div class="carousel-inner" role="listbox">
                    <div
                    class="carousel-item text-center"
                    v-for="noticia,index of noticias" :key="index+'not'">
                        <img
                        style="max-height:300px;width:100%;"
                        v-bind:src="noticia.imagen"
                        alt="First slide">
                        <div v-if="noticia.titulo != '' && noticia.descripcion_corta != ''" style="background: rgba(0, 0, 0, 0.75);" class="carousel-caption d-none d-md-block">
                            <h3 class="text-white">{{noticia.titulo}}</h3>
                            <p>{{noticia.descripcion_corta}}</p>
                        </div>
                    </div>
                </div>
                <a class="carousel-control-prev" href="#carouselExampleIndicators3" role="button" data-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#carouselExampleIndicators3" role="button" data-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>

import {mapActions} from 'vuex';

export default {
    data(){
        return {
            noticias:[]
        }
    },
    methods:{
        Consultar(){
          this.$http.get('configuracion/noticias')
          .then(respuesta=>{return respuesta.json()})
          .then(respuestaJson=>{
            this.noticias = respuestaJson;
            localStorage.setItem('imagenNoticia', this.noticias[0].imagen);
            $(document).ready(function(){
                $('#carouselExampleIndicators3').find('.li_carousel').each(function(i,element){
                    if (i==0) {
                        $(element).addClass('active');
                    }
                });
                $('#carouselExampleIndicators3').find('.carousel-item').each(function(i,element){
                    if (i==0) {
                        $(element).addClass('active');
                    }
                });
                $('.carousel').carousel();
            });
          })
          .catch(error=>{
          });
        },
    },
    mounted(){
        this.Consultar();
    }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/Noticias/Noticias.vue